import { msg } from '@gonfalon/messages/msg';
import {
  SearchField as AriaSearchField,
  composeRenderProps,
  FieldError,
  Group,
  IconButton,
  Input,
  Label,
  ProgressBar,
  type SearchFieldProps,
  Text,
} from '@launchpad-ui/components';
import { Icon } from '@launchpad-ui/icons';
import clsx from 'clsx';

import styles from './Form.module.css';

export type Props = SearchFieldProps & {
  label?: string;
  description?: string;
  placeholder?: string;
  errorMessage?: string;
  isBusy?: boolean;
};

export function SearchField({ placeholder, label, description, errorMessage, isBusy, ...props }: Props) {
  return (
    <AriaSearchField
      {...props}
      slot="search"
      className={composeRenderProps(props.className, (className) => clsx(className))}
    >
      {label && <Label>{label}</Label>}
      <Group>
        <Icon name="search" size="small" />
        <Input placeholder={placeholder} />
        {isBusy !== undefined && (
          <span className={styles.spinnerSlot} style={{ visibility: isBusy ? 'visible' : 'hidden' }}>
            <ProgressBar aria-label={msg('ui.status.loading')} isIndeterminate size="small" />
          </span>
        )}
        <IconButton
          aria-label={msg('ui.searchField.clearLabel')}
          icon="cancel-circle-outline"
          size="small"
          variant="minimal"
        />
      </Group>
      {description && <Text slot="description">{description}</Text>}
      {errorMessage && <FieldError>{errorMessage}</FieldError>}
    </AriaSearchField>
  );
}
